// Dependencias
require('./bootstrap');

import CurrencyText from './components/CurrencyText.vue';
import CurrencyInput from './components/CurrencyInput.vue';

import MensajeriaCotizacion from './components/cotizacion/MensajeriaCotizacion.vue';
import ModalReasignaciones from './components/cotizacion/ModalReasignaciones.vue';
import OrdenAsignacion from './components/cotizacion/OrdenAsignacion.vue';
import Recordatorios from './components/Recordatorios';
import MotosServicio from './components/agendamiento/MotosServicio';
import RepuestosMotoServicio from './components/agendamiento/RepuestosMotoServicio';

// Componentes
Vue.component('currency-text', CurrencyText);
Vue.component('currency-input', CurrencyInput);

// Cotización
Vue.component('mensajeria-cotizacion', MensajeriaCotizacion);
Vue.component('recordatorios', Recordatorios);
Vue.component('modal-reasignaciones', ModalReasignaciones);
Vue.component('orden-asignacion', OrdenAsignacion);

// Agendamiento
Vue.component('motos-servicio', MotosServicio);
Vue.component('repuestos-moto-servicio', RepuestosMotoServicio);

Vue.filter('prettyDate', function (strFecha, tipo) {
  tipo = tipo || 'long';
  const formato = tipo === 'long'
    ? 'dddd DD \\d\\e MMMM \\d\\e YYYY \\| HH:mm'
    : 'dddd DD \\d\\e MMMM \\d\\e YYYY';
  return moment(strFecha).format(formato);
});

Vue.filter('prettyDateV2', function (strFecha, tipo) {
  tipo = tipo || 'long';
  const formato = tipo === 'long'
    ? 'dd DD MMM YYYY \\| HH:mm'
    : 'dd DD MMM YYYY';
  return moment(strFecha).format(formato);
});

Vue.filter('prettyHour', function (strFecha) {
  return moment(strFecha).format('HH:mm');
});

// App
const app = new Vue();
const appEl = document.getElementById('app');

if (appEl !== null && !appEl.classList.contains('error')) {
  app.$mount('#app');
}



// WEBPACK FOOTER //
// ./resources/vue/app.vue.js